<template>
  <section class="contextual-info">
    <dl class="customer-information">
      <dt>Customer</dt>
      <dd>{{ sampleData.customer.customerName }}</dd>
      <dt>Attention</dt>
      <dd>{{ sampleData.customer.attention }}</dd>
      <dt>Address</dt>
      <dd>{{ sampleData.customer.address }}</dd>
      <dt>Email</dt>
      <dd>
        {{ sampleData.customer.email }}
        {{ sampleData.customer.allReportEmails }}
        {{ goodOrBadReportEmails }}
      </dd>
      <dt>Date Received</dt>
      <dd>{{ sampleData.coolantSample.dateReceived | formatDate }}</dd>
      <dt>Date Sampled</dt>
      <dd>{{ sampleData.coolantSample.dateSampled | formatDate }}</dd>
    </dl>
    <dl class="component-information">
      <dt>Unit Name</dt>
      <dd>{{ sampleData.unit.unitName }}</dd>
      <dt>Manufacturer</dt>
      <dd>{{ sampleData.unit.manufacturerModelName }}</dd>
      <dt>Unit Type</dt>
      <dd>{{ sampleData.unit.unitTypeName }}</dd>
      <dt>Oil Type</dt>
      <dd>{{ sampleData.coolantSample.fluidName }}</dd>
      <dt>Oil</dt>
      <dd>{{ sampleData.coolantSample.makeUpOil }}</dd>
      <dt>Meter Reading</dt>
      <dd>{{ sampleData.coolantSample.meterReading }}</dd>
      <dt>Oil Reading</dt>
      <dd>{{ sampleData.coolantSample.milesOrHoursOnSample }}</dd>
    </dl>
    <Severity :severityCode="sampleData.coolantSample.sampleSeverityCode" />
    <dl class="comment-information">
      <dt>Comment</dt>
      <dd>{{ sampleData.coolantSample.comments }}</dd>
      <dt>Customer Comment</dt>
      <dd>
        <textarea v-model="customerComment" @input="customerCommentChange"></textarea>
      </dd>
    </dl>
  </section>
</template>

<script>
import debounce from 'lodash.debounce';
import AjaxDataService from 'services/ajax.service';
import Constants from '../../../constants/constants';
import Severity from './CoolantSampleDetailSeverity.vue';

export default {
  name: 'CoolantSampleDetailContextualInfo',
  filters: {
    formatDate(value) {
      return new Date(value).toLocaleDateString();
    }
  },
  components: {
    Severity
  },
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  },
  created() {
    this.customerCommentChange = debounce(() => {
      const { coolantSampleID } = this.sampleData.coolantSample;

      AjaxDataService.putData(Constants.Api.Endpoint.CoolantSample.data, {
        coolantSampleID,
        CustomerComments: this.customerComment
      });
    }, Constants.Api.debounce.customerComment);
  },
  data() {
    return {
      customerComment: this.sampleData.coolantSample.customerComments
    };
  },
  computed: {
    goodOrBadReportEmails() {
      return this.sampleData.coolantSample.sampleSeverityCode === Constants.Severities.Normal
        ? this.sampleData.customer.goodReportEmails
        : this.sampleData.customer.badReportEmails;
    }
  }
};
</script>

<style lang="scss" scoped>
.contextual-info {
  align-items: flex-start;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;
  width: 100%;

  .customer-information,
  .component-information,
  .comment-information,
  .severity {
    padding: 0 10px;
    width: 100%;
  }

  .customer-information,
  .component-information,
  .comment-information {
    dt {
      float: left;
      font-weight: bold;

      &:not(.no-colon)::after {
        content: ':';
        margin-right: 5px;
      }

      a {
        cursor: pointer;
      }
    }

    dd {
      margin-left: 35%;
      min-height: 20px;
    }
  }

  .comment-information {
    textarea {
      width: 99%;
    }
  }
}
</style>
